import styled from 'styled-components'

interface IAuthenticationRequiredPromptStyledProps {}

export const AuthenticationRequiredPromptStyled = styled.div<IAuthenticationRequiredPromptStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  max-width: ${(props) => props.theme.typography.pxToRem(400)};
`
